import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { ResetUserPassword } from 'src/modules/user/components/reset-user-password/component';
import { UserApiService } from 'src/modules/user/services/user-api.service';
import { UserDataSource } from 'src/modules/user/services/user-data-source.service';
import User from 'src/modules/user/types/user';
import { BehaviorSubject, Subscription as RxSubscription } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { GenerateUserPassword } from 'src/modules/user/components/generate-user-password/component';

@Component({
    selector: 'retired-user-admin-dashboard',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class RetiredUserDashboard implements OnInit, OnDestroy {
  @Input() currentTab: BehaviorSubject<string>;

  public DataSource = new UserDataSource(
    this.UserApi,
    'retired-user-admin',
    'retiredUserAdmin'
  );
  private Subscriptions: RxSubscription[] = [];
  public loading: boolean;
  public Users: User[];
  public PageEvent: PageEvent;

  public displayedColumns = [
    'firstName',
    'lastName',
    'email',
    'employeeNumber',
    'branchNumber',
    'actions',
  ];

  constructor(
    private UserApi: UserApiService,
    private AuthService: AuthService,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.Subscriptions.push(
      this.DataSource.loading.subscribe((_loading) => (this.loading = _loading))
    );
    this.Subscriptions.push(
      this.DataSource.connect().subscribe((_Users) => (this.Users = _Users))
    );
    this.Subscriptions.push(
      this.DataSource.PageEvent.subscribe(
        (_PageEvent) => (this.PageEvent = _PageEvent)
      )
    );
    this.Subscriptions.push(
      this.DataSource.filter.subscribe(() =>
        this.DataSource.loadWithPageEvent(this.PageEvent)
      )
    );
    this.Subscriptions.push(
      this.currentTab.subscribe(
        (tab) =>
          'retired-user-admin' === tab &&
          this.DataSource.loadWithPageEvent(this.PageEvent)
      )
    );
  }

  public setSearch(search: string) {
    this.DataSource.setFilter('searchString', search);
  }

  userRole() {
    if (this.AuthService.inGroup('user-admin')) {
      return 'user-admin';
    }
    return 'retired-user-admin';
  }

  public resetUserPassword(User: User) {
    const config = new MatDialogConfig();

    config.disableClose = true;
    config.data = {
      User,
      dataSource: this.DataSource,
    };

    this.handleDialog(ResetUserPassword, config);
  }

  private handleDialog(component, config) {
    this.Subscriptions.push(
      this.dialog
        .open(component, config)
        .afterClosed()
        .subscribe(() => {
          this.DataSource.loadWithPageEvent(this.PageEvent);
        })
    );
  }

  public generateUserPassword(User: User) {
    const config = new MatDialogConfig();

    config.disableClose = true;
    config.data = {
      User,
      dataSource: this.DataSource,
    };

    this.handleDialog(GenerateUserPassword, config);
  }

  ngOnDestroy() {
    this.DataSource.disconnect();
    this.Subscriptions.forEach((Subscription) => Subscription.unsubscribe());
  }
}
